/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8254c23f3224da21c58f709d6b33ecb1>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "AlignContentTop".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Used for aligning top edges of content in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AlignContentTopIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "AlignContentTopIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.5h16V0H0zM4.38 3C3.62 3 3 3.62 3 4.38v9.25c0 .76.62 1.37 1.38 1.37h1.5c.76 0 1.38-.62 1.38-1.37V4.38C7.25 3.62 6.63 3 5.88 3zm.12 1.5h1.25v9H4.5zM10.13 3c-.76 0-1.37.62-1.37 1.38v4.25c0 .76.62 1.38 1.38 1.38h1.5C12.39 10 13 9.38 13 8.63V4.38C13 3.62 12.38 3 11.63 3zm.13 1.5h1.25v4h-1.25z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AlignContentTopIcon.displayName = 'AlignContentTopIcon';
var _default = exports.default = AlignContentTopIcon;